module.exports = __webpack_public_path__ + "static/img/guide-sider-btn.25b9214.png";